<div class="container-fluid pt-2">

  <div class="card">
    <div class="card-header">
      <ul class="nav nav-tabs card-header-tabs">
        @for (tab of tabs; track tab[0]) {
          <li class="nav-item">
            <a class="nav-link" routerLink="../{{tab[0]}}" routerLinkActive="active fw-bold">{{ tab[1] }}</a>
          </li>
        }
        <li class="nav-item">
          <a class="nav-link" routerLink="../export" routerLinkActive="active fw-bold">Export</a>
        </li>
      </ul>
    </div>
    <div class="card-body">
      @if (tab === 'export') {
        @if (forms.length) {
          <div class="row">
            <div class="mb-4">
              <h4 class="text-primary">Export als Excel Datei</h4>
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-12 col-lg-6">
              <div class="input-group input-group-sm mb-3">
                <label class="input-group-text" for="forms">Formular</label>
                <select class="form-select form-select-sm" id="forms" name="forms" [(ngModel)]="selectedForm">
                  @for (form of forms; track form.id) {
                    <option [ngValue]="form">{{form.name}}</option>
                  }
                </select>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3 mb-3">
              <div class="input-group input-group-sm">
                <label class="input-group-text" for="exportFrom">Von</label>
                <input type="date" class="form-control" id="exportFrom" name="exportFrom" max="9999-12-31" [(ngModel)]="exportFrom">
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3 mb-3">
              <div class="input-group input-group-sm">
                <label class="input-group-text" for="exportTo">Bis</label>
                <input type="date" class="form-control" id="exportTo" name="exportTo" max="9999-12-31" [(ngModel)]="exportTo">
              </div>
            </div>
            <div class="col-12">
              <button class="btn btn-sm btn-primary" (click)="export()">Export</button>
            </div>
          </div>
        }
      } @else {
        <div class="row mb-4">
          <div class="col-12 col-md-6 col-lg-3 mb-3">
            <div class="input-group input-group-sm">
              <label class="input-group-text" for="from">Von</label>
              <input type="date" class="form-control" id="from" name="from" [(ngModel)]="from">
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-3 mb-3">
            <div class="input-group input-group-sm">
              <label class="input-group-text" for="to">Bis</label>
              <input type="date" class="form-control" id="to" name="to" [(ngModel)]="to">
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-3 mb-3">
            <button class="btn btn-sm btn-primary" (click)="load()">Suchen</button>
          </div>
          @if (type === ProcessesViewType.MY) {
            <div class="col-12 col-md-6 col-lg-3 mb-3 text-end">
              <button class="btn btn-sm btn-primary" (click)="processService.downloadMyProcesses()">Alle meine Anträge
                herunterladen</button>
            </div>
          }
        </div>
        @if (!processes) {
          <div class="text-center m-auto mt-5">
            <rbb-loader />
            <small class="text-secondary d-block">Anträge werden geladen...</small>
          </div>
        }
        <app-processes-table [processes]="processes"/>
      }
    </div>
  </div>
</div>


<ng-template #ngModal>
  <div class="modal-header pb-2 pt-2">
    <h5 class="modal-title">
      <span>Export</span>
    </h5>
  </div>
  <div class="modal-body">
    <div class="text-center m-auto my-3">
      <rbb-loader/>
      <small class="text-secondary d-block">Anträge werden exportiert ...</small>
    </div>
  </div>
</ng-template>
